import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import qs from "qs"


/*
* 调用request方法
* 调用方式:
* 引入API: import { Xxx } from '@/api/xxx';
* 方式一：
* Xxx(params).then(res => {
*   console.log(res)
* });
*
* 方式二(ES7异步变同步)：
* async XXX(){
*   const res =  await Xxx(params);
*   console.log(res)
*   Next...
* }
* */


// 创建axios实例
const service = axios.create({
  // withCredentials: true,
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

let cookieInfo = {}
// request拦截器

service.interceptors.request.use(config => {
    //非简单请求
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  // debugger;
  if(getToken()) {
      cookieInfo = JSON.parse(getToken());
  }
  // console.log( cookieInfo.userId);
  if (store.getters.token) {
    config.headers['token'] = cookieInfo.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // debugger;
  if(config.method === "post" || config.method === "put" ) {

    // config.data.loginUserId = cookieInfo.userId
    config.data = qs.stringify(config.data);
    // config.data = {
    //     ...config.data,
    //     userId: cookieInfo.userId
    // }
  } else {
    // config.params.userId = cookieInfo.userId
    config.params = {
      loginUserId : cookieInfo.userId,
        ...config.params
    }
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
  /*
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.errorMsg,
        type: 'error',
        duration: 5 * 1000
      })


      return Promise.reject(res.errorMsg?res.errorMsg:'error')
    } else {
      return response.data
    }
  },
  error => {
    // console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js